import { mapState } from "vuex";

const minin = {
  data() {
    return {
    };
  },
  computed: {
    ...mapState([
      'store'
    ]),
  },
  methods: {
    getParams() {
      const { idx, iswork } = this.$route.params
      const { fleet } = this.store
      console.log(idx, iswork, fleet)
    },
  },
  mounted() {
    // this.setParams()
  },
}

export default minin